<template>
    <div class="col-12 p-0">
		<div class="alert alert-success alert-dismissible fade show" role="alert" v-if="message != ''">
			{{message}}
			<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <input type="text" class="form-control form-text pt-2 pb-2" :class="hasErrors('name') ? 'is-invalid' : ''" name="name" v-model="form.name" @keydown="onInput" placeholder="Name" />
                    <div v-if="hasErrors('name')" class="invalid-feedback">{{errors.name[0]}}</div>
                </div>
                <div class="form-group">
                    <input type="text" class="form-control form-text pt-2 pb-2" :class="hasErrors('email') ? 'is-invalid' : ''" name="email" v-model="form.email" @keydown="onInput" placeholder="Email" />
                    <div v-if="hasErrors('email')" class="invalid-feedback">{{errors.email[0]}}</div>
                </div>
                <div class="form-group">
                    <input type="text" class="form-control form-text pt-2 pb-2" :class="hasErrors('phone') ? 'is-invalid' : ''" name="phone" v-model="form.phone" @keydown="onInput" placeholder="Phone Number" />
                    <div v-if="hasErrors('phone')" class="invalid-feedback">{{errors.phone[0]}}</div>
                </div>
                <div class="form-group">
                    <textarea type="text" class="form-control form-text pt-2 pb-2" 
					rows="3" :class="hasErrors('message') ? 'is-invalid' : ''" name="message" v-model="form.message" @keydown="onInput" placeholder="Message" />
                    <div v-if="hasErrors('message')" class="invalid-feedback">{{errors.message[0]}}</div>
                </div>
                    <button type="submit" class="btn btn-secondary btn-block bg-alt-red border-danger mt-2 p-2" @click.prevent="submit">Send Message</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
	data() {
		return {
			form: {
				website: 'hsol',
				name: '',
				email: '',
				phone: '',
				message: ''
			},
			loading: false,
			submitted: false,
			message: '',
			errors: {}
		}
	},
	methods: {
		submit() {
			this.submitted = true
			this.loading = true
			axios
				.post(process.env.UNIVERSAL + '/api/hsol/enquiry', this.form, {
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
						'X-Requested-With': 'XMLHttpRequest'
					}
				})
				.then(({ data: { message } }) => {
					this.message = message
					this.loading = false
				})
				.catch(({ response: { data: { errors } } }) => {
					this.$nextTick(() => {
						this.errors = errors
					})
				})
		},
		onInput({ target: { name } }) {
			if (typeof this.errors === 'object' && this.hasErrors(name)) {
				delete this.errors[name]
			}
		},
		hasErrors(name) {
			return this.errors.hasOwnProperty(name)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/home/TalkWithUs.vue